import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const newFeedbackFunc = createAsyncThunk(
  "feedback/new",
  async (data) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/feedbacks`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        //   "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(data)
        return result;
      })
      .catch((error) => {
        console.log(data)
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const newFeedbackSlicer = createSlice({
  name: "feedback/new",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(newFeedbackFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(newFeedbackFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.message === " Feedback created Successfully") {
        state.data = action.payload.data;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(newFeedbackFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default newFeedbackSlicer.reducer;
